import React from "react"
import tinycolor from 'tinycolor2'

const TeamArray = ({ val }) => {

    // colors to help readability on team badge //
    const lighten = '#ffffff'
    const darken = '#000000'

    // get json //
    const teamJson = eval(val)
    
    if (teamJson == null) {

        return (
            // wrapper of all team badges //
            <div style={{
                display : 'flex',
                flexWrap : 'wrap',
                alignItems: 'center',
                justifyContent: 'start',
                width: '100%',
            }}>
            </div>
        )

    } else {

        return (
            // wrapper of all team badges //
            <div style={{
                display : 'flex',
                flexWrap : 'wrap',
                alignItems: 'center',
                justifyContent: 'start',
                width: '100%',
            }}>
                {teamJson.map((team) => {

                    const parsedTeam = JSON.parse(team)
                    return (

                        <div style={{
                            display : 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding : '4px',
                            margin : '4px',
                            backgroundColor : tinycolor.mix(lighten, parsedTeam['color'], 10),
                            color : tinycolor.mix(darken, parsedTeam['color'], 80),
                            fontSize : '.6rem',
                            borderRadius : '5px'
                        }} key={parsedTeam['team']}>
                            {parsedTeam['team']}
                        </div>
                    
                    )

                })}
            </div>
        )

    }
    
}

export default TeamArray